module.exports = __webpack_public_path__ + "img/resdob.50c3b77d.jpg";